import { Navigate, useParams } from 'react-router-dom';

/** Deep links from app/notifications use /orders/:orderId — send buyers to profile orders. */
export default function OrderDeepLink() {
  const { orderId } = useParams();
  if (!orderId) {
    return <Navigate to="/profile?tab=orders" replace />;
  }
  return <Navigate to={`/profile?tab=orders&orderId=${encodeURIComponent(orderId)}`} replace />;
}
